<script>
import axios from "axios";
import {BrandMenu, BrandsPath, MenuPath, StorePath} from "@/path";

export default {
  props : ['selectedMenu'],
  computed: {
    BrandsPath() {
      return BrandsPath
    },
    MenuPath() {
      return MenuPath
    },
    StorePath() {
      return StorePath
    }
  },
  components : {},
  data(){
    return {
      filter : [],
      baseUrl : process.env.VUE_APP_API_BACKEND_URL,
      menu_items : [],
      search_items : [],
      search_brand : [],
      form : {},
      fields : ["name","ref_id","brand","location","city","state","actions"],
      items_fields : ["name","ref_id","brand","location","city","state","actions"],
      search_items_api : BrandMenu.BRAND_SEARCH_MENU,
      search : '',
      search_two : '',
      items : [],
      current_page : 1,
      current_page_two : 1,
    }
  },
  mounted() {
    this.getMenuItems();
    this.getItems();
  },
  watch : {
    search(){
      this.getMenuItems();
    },
    search_two(){
      this.getItems();
    },
    current_page(){
      this.getMenuItems();
    },
    current_page_two(){
      this.getItems();
    },
    selectedMenu(){
      this.getMenuItems();
    }
  },
  methods : {
    async saveItem(v){
      try {
        let res = await axios.post(this.baseUrl + MenuPath.MENU_LOCATIONS,{
          menu_id : this.selectedMenu.id,
          locations : [v.id]
        });
        if(res.data.status){
          this.$bvToast.toast('Successfully added', {
            title: `Item added`,
            variant: 'success',
            solid: true
          });
          this.getItems();
        }
      }catch (e){
        console.log(e);
      }
    },
    async deleteItem(v){
      try{
        let res = await axios.post(this.baseUrl + MenuPath.MENU_LOCATIONS,{
          type : 'delete',
          locations : [v.id],
          menu_id : this.selectedMenu.id
        });
        if(res.data.status){
          this.$bvToast.toast('Successfully removed', {
            title: `Item removed`,
            variant: 'success',
            solid: true
          });
          this.getMenuItems();
          this.getItems();
        }
      }catch (e) {
        console.log(e);
      }
    },
    async getItems(){
      try {
        if(this.selectedMenu != null){
          let res = await axios.get(this.baseUrl + MenuPath.MENU_LOCATIONS,{
            params : {
              not_menu_id : this.selectedMenu.id,
              search : this.search_two,
              page : this.current_page_two
            }
          });
          if(res.data.status){
            this.items = res.data.data;
          }
        }
      }catch (e){
        console.log(e);
      }
    },
    async getMenuItems(){
      try {
        if(this.selectedMenu != null){
          let res = await axios.get(this.baseUrl + MenuPath.MENU_LOCATIONS,{
            params : {
              menu_id : this.selectedMenu.id,
              search : this.search,
              page : this.current_page
            }
          });
          if(res.data.status){
            this.menu_items = res.data.data;
          }
        }
      }catch (e){
        console.log(e);
      }
    }
  }
}
</script>

<template>
  <div class="row">
    <div class="col-12">
      <b-tabs>
        <b-tab title="Menu Locations" @click="(() => this.getMenuItems())">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive mb-0">
                <div class="pb-2 float-right w-25">
                  <b-row>
                    <b-col sm="12">
                      <b-input-group  size="sm">
                        <b-input-group-prepend is-text>
                          <i class="fa fa-search"></i>
                        </b-input-group-prepend>
                        <b-input size="sm" placeholder="Search" v-model="search"></b-input>
                      </b-input-group>
                    </b-col>
                  </b-row>
                </div>
                <b-table
                    :key="menu_items.key"
                    :items="menu_items.data"
                    :fields="fields"
                    responsive="sm"
                    :filter="filter"
                    :current-page="current_page"
                >
                  <!--                    <template v-slot:cell(brand)="row">-->
                  <!--                      <p>{{row.item.menu_items[0]?.brand?.name}}</p>-->
                  <!--                    </template>-->
                  <template v-slot:cell(brand)="row">
                    {{row.item.brand.name}}
                  </template>
                  <template v-slot:cell(actions)="row">
                    <b-button @click="deleteItem(row.item)" variant="danger" class="ml-1">
                      <i class="fa fa-trash"></i>
                    </b-button>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination :key="menu_items.key" v-model="current_page" :total-rows="menu_items.total" :per-page="menu_items.per_page"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab title="Add Location" @click="(() => this.getItems())">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive mb-0">
                <div class="pb-2 float-right w-25">
                  <b-row>
                    <b-col sm="12">
                      <b-input-group  size="sm">
                        <b-input-group-prepend is-text>
                          <i class="fa fa-search"></i>
                        </b-input-group-prepend>
                        <b-input size="sm" placeholder="Search" v-model="search_two"></b-input>
                      </b-input-group>
                    </b-col>
                  </b-row>
                </div>
                <b-table
                    :key="items.key"
                    :items="items.data"
                    :fields="items_fields"
                    responsive="sm"
                    :filter="filter"
                    :current-page="current_page_two"
                >
                  <template v-slot:cell(brand)="row">
                    {{row.item.brand.name}}
                  </template>
                  <template v-slot:cell(actions)="row">
                    <b-button @click="saveItem(row.item)" v-b-tooltip.hover title="Add to menu" class="mr-2" variant="primary">
                      <i class="fa fa-plus-square"></i>
                    </b-button>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination :key="items.key" v-model="current_page_two" :total-rows="items.total" :per-page="items.per_page"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<style>

</style>